import { useState } from 'react';
import { Typography, Button, ButtonVariants } from 'ui';
import { TypeScales } from 'ui/primitives';
import EmiCalculator from '../popups/EmiCalculator';
import { calculateEMI } from 'src/modules/emiCalculator/utils/calculate';
import s from './EmiOffer.module.scss';

export const EmiOffer = ({ price,handleGetEmiOffers }: { price?: number,handleGetEmiOffers?:()=>void }) => {
    const [showCalculator, setShowCalculator] = useState(false);
    const calculatedEmi = calculateEMI({ loanAmt: price, interest: 9, tenure: 7 });
    return (
        <div className={s.root}>
            <div className={s.emi}>
                <Typography
                    label={`EMI starts at ${calculatedEmi?.monthlyAmt}/month`}
                    className={s.heading}
                    variant={TypeScales.h3}
                />
                <div className={s.bottom_btn}>
                    <Button
                        label="EMI Calculator"
                        variant={ButtonVariants.BlackLink}
                        onClick={() => setShowCalculator(true)}
                    />
                    <Button
                        label="Get EMI offers"
                        onClick={handleGetEmiOffers}
                        variant={ButtonVariants.ButtonSecondary}
                        size="Small"
                    />
                </div>
            </div>
            {showCalculator && (
                <EmiCalculator
                    show={showCalculator}
                    onClose={() => setShowCalculator(false)}
                    price={price}
                />
            )}
        </div>
    )
}